import React from 'react';
import { Paper, Skeleton } from '@mantine/core';

export const LoadingState: React.FC = () => {
    return (
        <div className="space-y-4">
            {[1, 2, 3].map((item) => (
                <Paper key={item} p="md" withBorder radius="md">
                    <Skeleton height={20} width="40%" mb="sm" radius="md" />
                    <div className="grid grid-cols-2 gap-4">
                        <Skeleton height={120} radius="md" />
                        <Skeleton height={120} radius="md" />
                    </div>
                </Paper>
            ))}
        </div>
    );
};
